import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';
import { Helmet } from 'react-helmet-async';

import { useAppLayoutContextConsumer, Container } from '@occc-app/design-system';
import { OfferFragment } from '@occc/graphql';

import { OfferDetails } from './OfferDetails';
import { getOfferDetailsPageHeaderLinks } from './utils';

type OfferDetailsPageProps = {
  loading: boolean;
  error?: ApolloError;
  offer?: OfferFragment;
};

export const OfferDetailsPage = ({ loading, error, offer }: OfferDetailsPageProps) => {
  const links = useMemo(
    () => getOfferDetailsPageHeaderLinks(loading, offer?.name, error),
    [offer?.name, error, loading],
  );

  useAppLayoutContextConsumer(links);

  return (
    <>
      <Helmet>
        <title>Offer</title>
      </Helmet>
      <Container>
        <OfferDetails offer={offer} loading={loading} error={error} />
      </Container>
    </>
  );
};
